import { PERMISSIONS } from '../constants/permissions';
import { PLATFORM_MCP_COPY } from '../constants/platformMcpCopy';

const KEY = PERMISSIONS.PLATFORM_MCP;

/**
 * `keyTooltips` entry for the Platform MCP checkbox in an access editor.
 * `which`: 'partnerLimits' | 'companyLimits' | 'role'.
 */
export const platformMcpTooltips = (which) => {
  const tip = {
    partnerLimits: PLATFORM_MCP_COPY.partnerLimitsTip,
    companyLimits: PLATFORM_MCP_COPY.companyLimitsTip,
    role: PLATFORM_MCP_COPY.roleTip,
  }[which];
  return tip ? { [KEY]: tip } : {};
};

/**
 * `keyWarnings` entry while Platform MCP is being unticked: it was saved ON
 * (`savedKeys`) and is now off (`selectedKeys`). Everyone below loses access,
 * and their connected AI apps stop, on their next action.
 */
export const platformMcpUntickWarning = (savedKeys = [], selectedKeys = []) =>
  savedKeys.includes(KEY) && !selectedKeys.includes(KEY) ? { [KEY]: PLATFORM_MCP_COPY.untickWarning } : {};
